export enum QuickStartAttributeStatus {
	OPEN = 1,
	COMPLETED = 2,
	SKIPPED = 3
}

export type QuickStartAttributeValue = "completed" | "open" | "skipped";

export function quickstartValueToStatus(value: QuickStartAttributeValue): QuickStartAttributeStatus {
	switch (value) {
		case "open": return QuickStartAttributeStatus.OPEN;
		case "completed": return QuickStartAttributeStatus.COMPLETED;
		case "skipped": return QuickStartAttributeStatus.SKIPPED;
	}
}

export function quickstartStatusToValue(status: QuickStartAttributeStatus): QuickStartAttributeValue {
	switch (status) {
		case QuickStartAttributeStatus.OPEN: return "open";
		case QuickStartAttributeStatus.COMPLETED: return "completed";
		case QuickStartAttributeStatus.SKIPPED: return "skipped";
	}
}

export enum OnboardingAttributeStatus {
	OPEN = 1,
	COMPLETED = 2,
	SKIPPED = 3,
	MIGRATE_FROM_DLXP = 4,
	NO_MIGRATION = 5,
	MIGRATION_DONE = 6
}

export type OnboardingAttributeValue = "completed" | "skipped" | "open" | "migrate_from_dlxp" | "no_migration" | "migration_done";

export function onboardingValueToStatus(value: OnboardingAttributeValue): OnboardingAttributeStatus {
	switch (value) {
		case "open": return OnboardingAttributeStatus.OPEN;
		case "completed": return OnboardingAttributeStatus.COMPLETED;
		case "skipped": return OnboardingAttributeStatus.SKIPPED;
		case "migrate_from_dlxp": return OnboardingAttributeStatus.MIGRATE_FROM_DLXP;
		case "no_migration": return OnboardingAttributeStatus.NO_MIGRATION;
		case "migration_done": return OnboardingAttributeStatus.MIGRATION_DONE;
	}
}

export function onboardingStatusToValue(status: OnboardingAttributeStatus): OnboardingAttributeValue {
	switch (status) {
		case OnboardingAttributeStatus.OPEN: return "open";
		case OnboardingAttributeStatus.COMPLETED: return "completed";
		case OnboardingAttributeStatus.SKIPPED: return "skipped";
		case OnboardingAttributeStatus.MIGRATE_FROM_DLXP: return "migrate_from_dlxp";
		case OnboardingAttributeStatus.NO_MIGRATION: return "no_migration";
		case OnboardingAttributeStatus.MIGRATION_DONE: return "migration_done";
	}
}
